import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICO2BottleVM } from 'app/models/co2-bottle';

/**
 * Simple CO2 bottle gauge. Same fill principle as keg-svg
 * (factor = amount / size), but a cylinder shape and its own color (CO2 has no
 * beverage.color). No checkout/pour.
 */
@Component({
  selector: 'app-co2-svg',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  template: `
    <svg viewBox="25 0 210 227" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
      <!-- valve -->
      <rect x="122" y="0" width="16" height="16" rx="3" fill="#9aa5b1"></rect>
      <!-- bottle outline -->
      <rect x="98" y="12" width="64" height="205" rx="30" fill="#e4e7eb" stroke="#9aa5b1" stroke-width="2"></rect>
      <!-- fill -->
      <clipPath id="co2clip">
        <rect x="100" y="14" width="60" height="201" rx="28"></rect>
      </clipPath>
      <rect [attr.y]="y" [attr.height]="height" x="100" width="60"
            fill="#3aa0ff" clip-path="url(#co2clip)"></rect>
    </svg>
  `,
})
export class Co2SvgComponent implements OnChanges {
  @Input() item!: ICO2BottleVM;

  height = 0;
  y = 215;
  percent = 0;

  ngOnChanges(): void {
    if (!this.item) return;
    const totHeight = 201;
    const startY = 14;
    const size = this.item.size ?? 0;
    const amount = this.item.amount ?? 0;
    const factor = size <= 0 || amount <= 0 ? 0 : Math.min(amount / size, 1);
    this.height = totHeight * factor;
    this.y = startY + (totHeight - this.height);
    this.percent = Math.round(factor * 100);
  }
}
